export default {
  acceptanceDetail: {
    collapseTitle: {
      baseTitle: '开证申请',
      contractDetail: '合同信息',
      fileTitle: '附件上传',
      issuingInfo: '开证信息',
      accountingDoc: '会计凭证',
      acceptanceInfo: '承兑信息',
    },
    btnList: {
      save: '保存',
      submit: '提交审批',
      submitAccept: '确认承兑',
      payment: '生成付款单',
      upload: '上传附件',
      print: '打印',
      add: '新增',
      remove: '删除',
      copy: '复制',
      ladeOrder: '提单',
      viewLadeOrder: '查看提单',
      withdraw: '撤销',

      isAccpetComplete: '是否完全承兑',
      acceptCompleteDate: '完全承兑日期',
      isPayComplete: '是否完全付款',
    },
    goodsTable: {
      indexTitle: '序号',
      clCode: '信用证号',
      sortNo: '行号',
      acceptDate: '承兑日期',
      acceptAmount: '承兑金额',
      planPayDate: '应付汇日期',
      contractNo: '合同号',
      externalContractNo: '外部合同号',
      contractDetailNo: '合同行项目',
      remark: '备注',
      productNo: '物料号',
      productDesc: '物料描述',
      isArrivalDifference: '有不符点',
      isRefusePayment: '拒付',
      refusePaymentDueDate: '拒付到期日',
      isPaid: '已付款',
      statusFlag: '承兑状态',
      paidAmount: '已付款金额',
      unpaidAmount: '未付款金额',
      delayPaymentType: '部门公司押汇情况',
      delayPaymentType0: '不押汇',
      delayPaymentType1: '部门不押汇公司押汇',
      delayPaymentType2: '部门押汇公司不押汇',
      delayPaymentType3: '部门押汇且公司押汇',
      isLockExchangeRate: '是否锁汇',
    },
    lockExchangeRateTable: {
      title: '承兑锁汇信息',
      indexTitle: '序号',
      lockAmount: '锁汇金额',
      externalLockExchangeRate: '外部锁汇价',
      internalLockExchangeRate: '内部锁汇价',
      branchName: '锁汇银行名称',
      bankAccountNum: '锁汇银行账户号码',
    },
    delayPaymentTable: {
      title: '押汇信息',
      indexTitle: '序号',
      delayAmount: '押汇金额',
      delayExchangeRate: '押汇利率(%)',
      delayCost: '押汇费用',
      delayDate: '押汇日期',
      delayPaymentDate: '押汇到期日',
      branchName: '押汇银行名称',
      bankAccountNum: '押汇银行账户号码',
      businessDepartmentName: '部门',
      isLockExchangeRate: '是否锁汇',
    },
    delayLockExchangeRateTable: {
      title: '押汇锁汇',
    },
    payInfoTable: {
      title: '付款信息',
    },
    attachment: {
      title: '附件',
    },
    msg: {
      goodsMsg: '承兑信息未填写完整！',
      lockGoodsMsg: '锁汇信息未填写完整！',
      delyGoodsMsg: '押汇信息未填写完整！',
      delylockGoodsMsg: '议付信息未填写完整！',
      removeMsg: '请选择至少一条进行删除',
    },
  },
};
